import React from "react";
import "./KeyConsultants.css";

const KeyConsultants = () => {
  return (
    <div className="container mx-auto px-8 lg:p-0">
      <h1 className="text-center text-[35px] lg:text-[50px] text-[#002060] font-bold p-4 lg:pt-10 pb-10">
        KeyConsultants
      </h1>
      <div className="">
        <div
          className="flex flex-col justify-center items-center"
          data-aos="fade-right"
        >
          <img
            src="https://i.ibb.co/kcSbQt9/Vineet-Sethi.jpg"
            alt="Mind Works Owner Introduction"
          />
          <p className="lg:w-[1400px] lg:text-[22px] text-center mt-[70px] mb-[70px]">
            Vineet Sethi is a renowned business coach and CI consultant with
            over two decades of experience in operational excellence. He has
            worked with companies across industries around the globe to help
            them achieve continuous improvement and build a culture of winning
            and success. An industry leader in driving change, Vineet has worked
            with teams across the entire value chain to align the objectives of
            the company to each individual team. A garment industry maestro, he
            now works with organizations across industries to provide customized
            solutions through strategy development and deployment. Over the
            years, apart from technical knowledge, he has also brought in the
            principles of Psychology in business. He is a certified NLP Coach
            which enables him to program a person’s mind to inculcate positive
            behaviour patterns. Vineet is a master trainer and is known for
            bringing each training session to life through innovative teaching
            methodologies.
          </p>
        </div>

        <div
          className="flex flex-col justify-center items-center"
          data-aos="fade-right"
        >
          <img
            src="https://i.ibb.co/B2rw0bnS/Naijur-01.jpg"
            className="clientImages"
            alt="Mind Works Owner Introduction"
          />
          <p className="lg:w-[1400px] lg:text-[22px] text-center mt-[70px] mb-[70px]">
            Naijur Rahman is a distinguished expert in Operational Excellence
            and Continuous Improvement in Bangladesh, known for his extensive
            experience in Lean Transformation, Lean Factory Design, Process
            Optimization, and Six Sigma Deployment across diverse industries. He
            focuses on strengthening and reshaping the knowledge, skills, and
            habits of employees, driving excellence through people
            transformation, and enabling organizations to achieve sustainable
            success. With a professional journey spanning over 25 years—and more
            than 13 years dedicated to training and development—Naijur has
            firmly established his reputation in the training, consulting, and
            organizational development domains. <br />
            As the Founder and Lead Consultant of Mind Works, an international
            training, development, and CI consulting organization, Naijur has
            conducted over 3,500 training sessions, delivering approximately
            60,000+ hours of commercial training to more than 70,000
            professionals—ranging from shop floor operators to C-suite
            executives—across corporate and public sectors. His areas of
            specialization include Soft Skills, Adult Learning & Facilitation,
            Cultural Transformation, Lean Six Sigma, Efficiency, and
            Productivity Improvement. <br />
            <br />
            <br />
            In addition to his training and consulting work, Naijur serves as an
            Adjunct Faculty at institutions such as IBA-DU, East West
            University, and Bangladesh Institute of Management (BIM). He is also
            an enlisted Senior Trainer for the ADB-funded SEIP Program under
            BGMEA, LFMEAB, and IBA, and a member of the Global Trainers’ Pool of
            K-Line Ship Management, Singapore. Furthermore, he is the Regional
            Operational Excellence Consultant for Eurofins, covering Bangladesh,
            India, and Sri Lanka. <br />
            <br /> Naijur holds the rare distinction of being the only
            Bangladeshi Lean/Kaizen expert selected by ROSATOM—the
            internationally acclaimed pioneer in nuclear power plant
            construction and the lead organization behind the Rooppur Nuclear
            Power Plant in Bangladesh—to provide Lean Kaizen support for
            resolving critical operational challenges at their partner sites.
            <br />
            <br />
            He is an Internationally Certified Trainer-of-Trainers (TOT)
            Professional, Lean Six Sigma Master Black Belt, Lean Six Sigma Black
            Bet, Certified Lean Champion, Guide & Coach, TRIZ Practitioner,
            Hoshin Kanri Practitioner, and a Habit Re-programmer & Reiki
            Practitioner. Academically, he earned his MBA and BBA from East West
            University, Dhaka. Naijur’s commitment to continuous improvement and
            his transformative impact on individuals and organizations make him
            one of the foremost thought leaders in Operational
            Excellence in Bangladesh.
          </p>
        </div>

        <div
          className="flex flex-col justify-center items-center"
          data-aos="fade-right"
        >
          <img
            src="https://i.ibb.co/DfTSDFTr/Monirujjaman-Munna-01.jpg"
            alt="Mind Works Owner Introduction"
          />
          <p className="lg:w-[1400px] lg:text-[22px] text-center mt-[70px] mb-[70px]">
            Monirujjaman Munna is a seasoned professional with over nine years
            of experience in manufacturing and process excellence. He
            specializes in Lean Six Sigma, Data Analysis, Quality Assurance,
            Process Optimization, and Project Management. Having working
            experience as a Cell Lead Manager and IWS (Integrated Work System)
            Implementation Leader at International Tobacco International (ITI),
            a subsidiary of Japan Tobacco International, he plays a key role in
            driving operational efficiency and system-based performance
            improvement. He has hands on experience at PRAN-RFL Group (APBL) as
            a Production Head, where he also served as a Lean Six Sigma Trainer
            and Implementation Leader, leading multiple process transformation
            initiatives and capability-building programs. A certified trainer
            accredited by The Lean Six Sigma Company in the Netherlands,
            Monirujjaman holds Lean Six Sigma Black Belt (LSSBB) and Post HBO
            Black Belt certifications. He is also a certified Internal Auditor
            for Integrated Management Systems, including ISO 9001, 14001, and
            45001. With a B.Sc. in Industrial and Production Engineering from
            Khulna University of Engineering & Technology (KUET), he brings a
            strong academic foundation to his practical expertise. Passionate
            about driving efficiency and fostering a culture of continuous
            improvement, Monirujjaman has successfully led numerous initiatives
            that enhanced operational performance and quality outcomes across
            diverse organizational settings.
          </p>
        </div>
        <div
          className="flex flex-col justify-center items-center"
          data-aos="fade-right"
        >
          <img
            src="https://i.ibb.co.com/V3ZSCYn/hr-01.png"
            className="clientImages"
            alt="Mind Works Owner Introduction"
          />
          <p className="lg:w-[1400px] lg:text-[22px] text-center mt-[70px] mb-[70px]">
            Shah Shakir Newaz An accomplished HR professional with over 18 years
            of progressive experience across diverse industries, including
            manufacturing, commercial banking, distribution, and logistics at
            both local and multinational levels. Expert in designing and
            executing HR strategies that align with organizational goals and
            drive sustainable business outcomes.
            <br />
            <br />
            Key Expertise Highlights :<br />
            •Change Management & HR Transformation: Led multiple organization
            restructuring initiatives,optimizing resource allocation, and
            driving sustainable improvements in productivity.
            <br /> •Talent Management: Spearheaded the design and implementation
            of comprehensive talent assessment tools, IDP frameworks, and
            succession planning strategies, fostering high-potential talent and
            future leaders. <br />
            •Performance Management: Transformed performance management systems
            by introducing merit-based increments and innovative performance
            calibration models, reducing reliance on outdated systems.
            <br /> •Cultural Change: Successfully led cultural change
            initiatives, including the rollout of new organizational values and
            diversity strategies, achieving significant awareness and inclusion
            milestones.
          </p>
        </div>
        <div
          className="flex flex-col justify-center items-center"
          data-aos="fade-right"
        >
          <img
            src="https://i.ibb.co.com/9YwWjBc/sifat-zaman-01.png"
            className="clientImages"
            alt="Mind Works Owner Introduction"
          />
          <p className="lg:w-[1400px] lg:text-[22px] text-center mt-[70px] mb-[70px]">
            Sifat Zaman is a BSC Engineer in IPE from SUST and Post Graduate
            Diploma in Apparel Supply Chain having 12 years of working
            experience as Head of IE, Production, and Operational Excellence in
            different Apparel Manufacturing Units. He is well-versed in
            implementing lean culture and process optimization. He is a hands-on
            Lean practitioner, an engineering leader & trainer for all section
            leaders for process, system, and workstation development to gain
            optimum output. He is well-trained in Process Re-engineering, and
            process optimization which results in better productivity and
            profitability of the companies. He has obtained training in the
            Sustainable Efficiency Improvement Drive Project from Mind Works for
            a duration of 2 years, Facility Layout Design of Garment Industry
            from Consiglieri Privet Ltd., “Production Management of Garment
            Industry” by Consiglieri Privet Ltd. , “5S & Visual Management” at
            Intertek Bangladesh. And 6-month-long training on “Benefits for
            Business and Workers (BBW)” by Rajesh Bheda Consulting, India, and
            Impactt Bangladesh Ltd .
          </p>
        </div>
        <div
          className="flex flex-col justify-center items-center"
          data-aos="fade-right"
        >
          <img
            src="https://i.ibb.co.com/djJFzkz/zaman-01.png"
            className="clientImages"
            alt="Mind Works Owner Introduction"
          />
          <p className="lg:w-[1400px] lg:text-[22px] text-center mt-[70px] mb-[70px]">
            Zaman Hossain holds several national and international professional
            training qualifications like LEAN SIX Sigma Black Belt, Green Belt,
            Transformational Leadership Program, LEAN Leader, Training of
            Trainers, Leadership, ISO 9001: QMS Lead Auditing, Internal Auditing
            for Occupational Health and Safety Management System based on BS
            OHSAS 18001: 2007, Rotary Leadership Graduation, Interviewing
            Skills, Time Management, Stress Management, Communication Skills,
            Sales Force Management, Business Plan Development, Managing People
            and Performance, Brand Management, Export Marketing, Office
            Management, 5S etc. Zaman Hossain is experienced on conducting
            Training and Projects on LEAN Certification Programs, 5S, Customer
            Behavior and Excellent Customer Service, Professional Selling Skills
            and Secret of Success, Marketing & Salesmanship, Customer
            Relationship through Marketing Success, Developing Marketing Skills
            and Techniques, Marketing Management, Sales Management at Bangladesh
            Institute of Management, DCCI Business Institute, Continuing
            Education Center. Zaman Hossain is also serving at some social/
            professional organizations like Rotary International, Junior Chamber
            International, Toastmaster International, Professional Society of
            Bangladesh, BIM – Alumni Association, Bangladesh Apparel
            Professionals Society, Bangladesh Society for Human Resources
            Management, SCITI Alumni Association of Bangladesh, Apparel
            Executive Club, Bangladesh Society for Total Quality Management etc.
          </p>
        </div>
      </div>
    </div>
  );
};

export default KeyConsultants;
